import store from '../store'
import { fetch } from 'redux-simple-auth'
import { HttpLink } from 'apollo-link-http'

const httpLink = new HttpLink({
  uri: `${process.env.REACT_APP_API_HOST}/graphql`,
  fetch: (uri, options) => store.dispatch(fetch(uri, options))
})

export default httpLink



// WEBPACK FOOTER //
// ./src/config/apollo/httpLink.js